import { SKILL_NAMES } from 'js/src/agent/skills/skillNames';
import { TOOL_NAMES } from 'js/src/agent/toolNames';
import type { Skill } from '../types';

export const findDamMediaSkill: Skill = {
    name: SKILL_NAMES.findDamMedia,
    description:
        "Searching the team's connected DAM (brand asset library) effectively. When a DAM is available, consider it for any company/brand/corporate content — alongside the user's uploads, not just when they name the DAM.",
    kind: 'howto',
    surfaces: ['sketch'],
    get instructions(): string {
        return `# Finding Media in the Brand Library (DAM)

The team's DAM holds brand-owned assets — prefer them over stock whenever they
cover the scene. Search with \`${TOOL_NAMES.searchDamMedia}\`.

## Keyword strategy
DAM search matches against tags/titles/descriptions with little or no fuzzy
matching, so descriptive phrases usually return nothing. Pass several short,
tag-like keywords instead — synonyms, broader and narrower terms, singular and
plural — in one call: instead of "campfire burning at night", pass
\`["campfire", "camping", "camping night", "bonfire"]\`. The tool runs them together
and de-duplicates the results.

## Limits to know
- Externally-hosted DAM assets (Brandfolder, Getty, Storyblocks, …) **cannot** be
  read by \`${TOOL_NAMES.analyzeVideo}\` or \`${TOOL_NAMES.imageAsk}\` — judge them from their metadata and
  thumbnails, and prefer a quick visual check in the built scene afterwards.
- The same suitability bar as any media applies: relevant to the
  scene, not a logo/chart fragment used as scene media.
- DAM assets beat stock, but the user's directly-attached media still comes first.`;
    },
};
